import "./icons.css";

import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { kebabCase } from "lodash-es";
import React from "react";

import Dummy from "~/images/dummy.jpg";
import TeamLogo from "~/images/TeamLogoIcon.png";

export interface StatusIconProps {
  center?: boolean;
  size?: SizeProp | undefined;
  className?: string;
  color?: string;
}

export function LoadingIcon(props: StatusIconProps) {
  const { center, size = "5x", className, color } = props;
  return (
    <FontAwesomeIcon
      icon="futbol"
      spin
      size={size}
      className={classNames(center ? "icon-center" : "", className)}
      color={color}
    />
  );
}

export function ErrorIcon(props: StatusIconProps) {
  const { center, className } = props;
  return (
    <FontAwesomeIcon
      icon={["fal", "exclamation-circle"]}
      size="5x"
      className={classNames(center ? "icon-center" : "", className)}
    />
  );
}

export function TeamLogoIcon(props: { size: string }) {
  const { size } = props;
  const classes = classNames("it-team-logo", size);
  return <img className={classes} src={TeamLogo} alt="team-logo" />;
}

export function PlayerIcon() {
  return (
    <div className="player-icon-div">
      <img src={Dummy} alt="player" />
    </div>
  );
}

export interface FlagIconProps {
  nationality?: string;
  className?: string;
  size?: number;
}

export const FlagIcon: React.FC<FlagIconProps> = (props) => {
  const { nationality, className = "", size = 32 } = props;
  if (!nationality) {
    return null;
  }
  return (
    <img
      className={className}
      src={`https://flagicons.lipis.dev/flags/4x3/${kebabCase(
        nationality
      )}.svg`}
      alt={nationality}
      height={size}
    />
  );
};
